import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        <div className="d-flex flex-wrap gap-2 justify-content-center">
          {props.buttons.map((button, index) => (
            <Button
              key={index}
              variant="primary"
              href={button.link}
              target="_blank"
            >
              {button.logo} &nbsp;
              {button.text}
            </Button>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
